export default [
  {
    path: '/admin/daily-attendances',
    name: 'daily-attendance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/daily-attendance')
  }
]
